const constants = {
    COLOR_CODE_BLACK: '#000000',
    COLOR_CODE_WHITE: '#ffffff',
    COLOR_CODE_TRANSPARENT: 'transparent',

    COLOR_CODE_MERCURY: '#e8e8e8',
    COLOR_CODE_ALTO: '#D4D4D4',

    COLOR_CODE_PIGMENT_INDIGO: '#360082',
    COLOR_CODE_BLACK_RUSSIAN: '#160028',
    COLOR_CODE_STRATOS: '#00003f',
    COLOR_CODE_GREEN: '#00ff00',
    COLOR_CODE_VERMILLION: '#FF3900',
    COLOR_CODE_SUPERNOVA: '#FFCA00',
    COLOR_CODE_FLUSH_ORANGE: '#FF7F00',
    COLOR_CODE_MELROSE: '#BFAEFF',

    BLOCK_EVENT_LIST_TITLE_SCHEME_LIGHT: 'light',
    BLOCK_EVENT_LIST_TITLE_SCHEME_LEGAL: 'legal',
    BLOCK_EVENT_LIST_TITLE_SCHEME_DARK: 'dark',
    BLOCK_EVENT_LIST_TITLE_SCHEME_ACCENT: 'accent',

    FADE_IN_SCROLL_SELECTOR: '.fade-in-scroll',
    FADE_IN_SCROLL_ACTIVE_CLASS: 'fade-in-scroll--active',
    FADE_IN_SCROLL_PX_OFFSET: 20,

    BLOCK_JUMP_MENU_INTERNAL_LINK_CLASS: 'block-jump-menu__wrapper__internal__link',
    BLOCK_JUMP_MENU_ANCHOR_TARGET_SELECTOR: '[data-jump-menu-anchor-target]',
    BLOCK_JUMP_MENU_ANCHOR_SELECTOR: '[data-jump-menu-anchor]',
    BLOCK_JUMP_MENU_ANCHOR_LINK_ATTR: 'data-jump-menu-anchor-link',
    BLOCK_JUMP_MENU_ANCHOR_ATTR_ID: 'data-jump-menu-anchor-id',
    BLOCK_JUMP_MENU_ANCHOR_ATTR_TITLE: 'data-jump-menu-anchor-title',

    BREAKPOINT_PX_XS: 480,
    BREAKPOINT_PX_S: 624,
    BREAKPOINT_PX_SM: 768,
    BREAKPOINT_PX_M: 896,
    BREAKPOINT_PX_MD: 1024,
    BREAKPOINT_PX_L: 1195,
    BREAKPOINT_PX_LG: 1366,

    BREAKPOINT_XS: 'xs',
    BREAKPOINT_S: 's',
    BREAKPOINT_SM: 'sm',
    BREAKPOINT_M: 'm',
    BREAKPOINT_MD: 'md',
    BREAKPOINT_L: 'l',
    BREAKPOINT_LG: 'lg',

    BLOCK_COLUMN_DEFAULT_FADE_IN: false,
    BLOCK_COLUMN_HIDE_COLUMN_DEVICE: false,

    BLOCK_COLUMN_WIDTH_FULL: 'full',
    BLOCK_COLUMN_WIDTH_TWO_THIRDS: 'two-thirds',
    BLOCK_COLUMN_WIDTH_HALF: 'half',
    BLOCK_COLUMN_WIDTH_THIRD: 'third',
    BLOCK_COLUMN_WIDTH_FOURTH: 'fourth',

    BLOCK_COLUMN_TOP_MARGIN_ZERO: 'zero',
    BLOCK_COLUMN_TOP_MARGIN_SMALL: 'small',
    BLOCK_COLUMN_TOP_MARGIN_MEDIUM: 'medium',
    BLOCK_COLUMN_TOP_MARGIN_LARGE: 'large',

    BLOCK_LOGOS_COLUMNS_THREE_COLUMNS: 'Three columns',
    BLOCK_LOGOS_COLUMNS_TWO_COLUMNS: 'Two columns',

    BLOCK_CONTAINER_SIZE_LARGE: 'large',
    BLOCK_CONTAINER_SIZE_MEDIUM: 'medium',
    BLOCK_CONTAINER_SIZE_SMALL: 'small',
    BLOCK_CONTAINER_SIZE_ZERO: 'zero',

    VERTICAL_ALIGNMENT_TOP: 'top',
    VERTICAL_ALIGNMENT_CENTER: 'center',
    VERTICAL_ALIGNMENT_BETWEEN: 'between',
    VERTICAL_ALIGNMENT_BOTTOM: 'bottom',

    HORIZONTAL_ALIGNMENT_LEFT: 'left',
    HORIZONTAL_ALIGNMENT_CENTER: 'center',
    HORIZONTAL_ALIGNMENT_BETWEEN: 'between',
    HORIZONTAL_ALIGNMENT_RIGHT: 'right',

    BLOCK_COLUMN: 'bz-block/column-block',
    BLOCK_CONTAINER: 'bz-block/container-block',
    BLOCK_EVENT_LIST: 'bz-block/event-list-block',
    BLOCK_HERO_EXHIBITIONS: 'bz-block/hero-exhibitions-block',
    BLOCK_QUOTE: 'bz-block/quote-block',
    BLOCK_UPCOMING_EXHIBITIONS: 'bz-block/upcoming-exhibitions-block',
    BLOCK_EXHIBITION: 'bz-block/exhibition-block',
    BLOCK_EXHIBITION_COLUMN: 'bz-block/exhibition-column-block',
    BLOCK_EXHIBITION_IMAGE: 'bz-block/exhibition-image-block',
    BLOCK_EXHIBITION_POST_HEADER: 'bz-block/exhibition-post-header-block',
	BLOCK_ESSENTIAL_INFO: 'bz-block/essential-info-block',
	BLOCK_EVENT: 'bz-block/event-block',
	BLOCK_EVENT_POST_HEADER: 'bz-block/event-post-header-block',
	BLOCK_JUMP_MENU: 'bz-block/jump-menu-block',
	BLOCK_JUMP_MENU_ANCHOR: 'bz-block/jump-menu-anchor-block',
	BLOCK_JUMP_MENU_EXTERNAL_LINK: 'bz-block/jump-menu-external-link-block',
	BLOCK_FULL_WIDTH_IMAGE: 'bz-block/full-width-image-block',
    BLOCK_NEWSLETTER_SIGNUP: 'bz-block/newsletter-signup-block',
    BLOCK_GOOGLE_MAPS_EMBED: 'bz-block/google-maps-embed-block',
    BLOCK_PRODUCT: 'bz-block/product-block',
    BLOCK_PRODUCT_POST_HEADER: 'bz-block/product-post-header-block',
    BLOCK_PRODUCT_INFO: 'bz-block/product-info-block',
    BLOCK_PRODUCT_COLUMN: 'bz-block/product-column-block',
    BLOCK_PRODUCT_IMAGES: 'bz-block/product-images-block',
    BLOCK_PRODUCTS: 'bz-block/products-block',
    BLOCK_LOGOS: 'bz-block/logos-block',
    BLOCK_LOGO_IMAGE: 'bz-block/logo-image-block',

};

constants.BREAKPOINTS = [
    {
        name: constants.BREAKPOINT_LG,
        value: constants.BREAKPOINT_PX_LG
    },
    {
        name: constants.BREAKPOINT_XS,
        value: constants.BREAKPOINT_PX_XS
    },
    {
        name: constants.BREAKPOINT_SM,
        value: constants.BREAKPOINT_PX_SM
    },
    {
        name: constants.BREAKPOINT_M,
        value: constants.BREAKPOINT_PX_M
    },
    {
        name: constants.BREAKPOINT_MD,
        value: constants.BREAKPOINT_PX_MD
    },
    {
        name: constants.BREAKPOINT_L,
        value: constants.BREAKPOINT_PX_L
    },
    {
        name: constants.BREAKPOINT_S,
        value: constants.BREAKPOINT_PX_S
    },
];

constants.BLOCK_CONTAINER_DEFAULT_BACKGROUND_COLOR = constants.COLOR_CODE_TRANSPARENT;

constants.BLOCK_CONTAINER_DEFAULT_VERTICAL_ALIGNMENT = constants.VERTICAL_ALIGNMENT_TOP;
constants.BLOCK_CONTAINER_VERTICAL_ALIGNMENTS = [
    constants.VERTICAL_ALIGNMENT_TOP,
    constants.VERTICAL_ALIGNMENT_CENTER,
    constants.VERTICAL_ALIGNMENT_BETWEEN,
    constants.VERTICAL_ALIGNMENT_BOTTOM,
];

constants.BLOCK_CONTAINER_DEFAULT_HORIZONTAL_ALIGNMENT = constants.HORIZONTAL_ALIGNMENT_LEFT;
constants.BLOCK_CONTAINER_HORIZONTAL_ALIGNMENTS = [
    constants.HORIZONTAL_ALIGNMENT_LEFT,
    constants.HORIZONTAL_ALIGNMENT_CENTER,
    constants.HORIZONTAL_ALIGNMENT_BETWEEN,
    constants.HORIZONTAL_ALIGNMENT_RIGHT,
];

constants.BLOCK_COLUMN_DEFAULT_WIDTH = constants.BLOCK_COLUMN_WIDTH_HALF;
constants.BLOCK_COLUMN_WIDTHS = [
    constants.BLOCK_COLUMN_WIDTH_FULL,
    constants.BLOCK_COLUMN_WIDTH_TWO_THIRDS,
    constants.BLOCK_COLUMN_WIDTH_HALF,
    constants.BLOCK_COLUMN_WIDTH_THIRD,
    constants.BLOCK_COLUMN_WIDTH_FOURTH,
];

constants.BLOCK_LOGOS_COLUMNS = {};
constants.BLOCK_LOGOS_COLUMNS[constants.BLOCK_LOGOS_COLUMNS_THREE_COLUMNS] = 1;
constants.BLOCK_LOGOS_COLUMNS[constants.BLOCK_LOGOS_COLUMNS_TWO_COLUMNS] = 2;

constants.BLOCK_LOGOS_COLUMNS_DEFAULT = constants.BLOCK_LOGOS_COLUMNS[constants.BLOCK_LOGOS_COLUMNS_THREE_COLUMNS];

constants.BLOCK_COLUMN_DEFAULT_TOP_MARGIN = constants.BLOCK_COLUMN_TOP_MARGIN_ZERO;
constants.BLOCK_COLUMN_TOP_MARGINS = [
    constants.BLOCK_COLUMN_TOP_MARGIN_ZERO,
    constants.BLOCK_COLUMN_TOP_MARGIN_SMALL,
    constants.BLOCK_COLUMN_TOP_MARGIN_MEDIUM,
    constants.BLOCK_COLUMN_TOP_MARGIN_LARGE
];

constants.BLOCK_CONTAINER_SIZE_DEFAULT = constants.BLOCK_CONTAINER_SIZE_MEDIUM;
constants.BLOCK_CONTAINER_SIZES = [
    constants.BLOCK_CONTAINER_SIZE_LARGE,
    constants.BLOCK_CONTAINER_SIZE_MEDIUM,
    constants.BLOCK_CONTAINER_SIZE_SMALL,
    constants.BLOCK_CONTAINER_SIZE_ZERO,
];

constants.BLOCK_EVENT_LIST_TITLE_SCHEME_DEFAULT = constants.BLOCK_EVENT_LIST_TITLE_SCHEME_LIGHT;
constants.BLOCK_EVENT_LIST_TITLE_SCHEMES = [
    constants.BLOCK_EVENT_LIST_TITLE_SCHEME_LIGHT,
    constants.BLOCK_EVENT_LIST_TITLE_SCHEME_LEGAL,
    constants.BLOCK_EVENT_LIST_TITLE_SCHEME_DARK,
    constants.BLOCK_EVENT_LIST_TITLE_SCHEME_ACCENT
];

constants.CONTAINER_BG_COLORS = [
    constants.COLOR_CODE_TRANSPARENT,
    constants.COLOR_CODE_BLACK,
    constants.COLOR_CODE_WHITE,
    constants.COLOR_CODE_MERCURY,
    constants.COLOR_CODE_ALTO,
    constants.COLOR_CODE_PIGMENT_INDIGO,
    constants.COLOR_CODE_BLACK_RUSSIAN,
    constants.COLOR_CODE_STRATOS,
];

constants.CONTAINER_BG_COLOR_NAMES = [
    'Transparent',
    'Black',
    'White',
    'Mercury',
    'Alto',
    'Pigment indigo',
    'Black Russian',
    'Stratos',
];

constants.COLORS = [
    constants.COLOR_CODE_BLACK,
    constants.COLOR_CODE_WHITE,
];
constants.COLOR_NAMES = [
    'BLACK',
    'WHITE',
];

export default constants;



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/constants.js